import { useSelector, useDispatch } from 'react-redux';
import { Box, Switch, Text } from '@rsos/base-components';
import {
  selectActiveCapabilities,
  setCapability,
  StateWithPsaps,
} from '@rsos/reduxDataStore';
import styled from '@rsos/theme/styled';

const Item = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  align: 'center',
  padding: '0 8px',
})`
&:hover {
  background-color: ${({ theme }) => theme.colors.highlights};
`;

interface CapabilityItemProps {
  name: string;
  displayName: string;
}

const CapabilityItem = ({ name, displayName }: CapabilityItemProps) => {
  const dispatch = useDispatch();
  const capability = useSelector(
    (s: StateWithPsaps) => selectActiveCapabilities(s)[name],
  );

  const onClick = (v: boolean) => {
    dispatch(
      setCapability({
        name,
        // Category 1, here, will break some things: spatial layers, at least!
        // This isn't a real capability, it's a hacky made-up one.
        value: v ? { name, display_name: displayName, category: 1 } : null,
      }),
    );
  };

  const label = capability?.display_name || displayName;

  // Long hardcoded fallback names (no API display name) overflow the row and
  // push the Switch off screen; truncate them with an ellipsis + full-name tooltip.
  const truncate = label === displayName;

  return (
    <Item>
      <Text
        size="normal"
        color="primaryText"
        ellipsis={truncate}
        title={truncate ? displayName : undefined}
        style={truncate ? { flex: 1, minWidth: 0 } : undefined}
      >
        {label}
      </Text>
      <Switch isOn={!!capability} onClick={() => onClick(!capability)} />
    </Item>
  );
};

export default CapabilityItem;
